import axios from 'axios';
import { GET, polusBaseUrl } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';

export function getGstOverviewService(orgId: string) {
    return axios({
        baseURL: polusBaseUrl,
        url: `/unifier/insights/gstOverview`,
        method: GET,
        params: { orgId, requestId: getTimeStamp() },
    });
}
